import React from "react";

export const EmailIcon: React.FC = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 40C6.2 40 5.5 39.7 4.9 39.1C4.3 38.5 4 37.8 4 37V11C4 10.2 4.3 9.5 4.9 8.9C5.5 8.3 6.2 8 7 8H28.7C28.6 8.5 28.5333 9 28.5 9.5C28.4667 10 28.4833 10.5 28.55 11H7.25L24 21.9L31.55 17C31.8833 17.3 32.2333 17.5778 32.6 17.8335C32.9667 18.0895 33.35 18.3117 33.75 18.5L24 24.9L7 13.75V37H41V19C41.5597 18.8407 42.083 18.6175 42.57 18.3305C43.0567 18.0435 43.5333 17.7167 44 17.35V37C44 37.8 43.7 38.5 43.1 39.1C42.5 39.7 41.8 40 41 40H7ZM37.994 15.5C36.4647 15.5 35.1667 14.9647 34.1 13.894C33.0333 12.8233 32.5 11.5233 32.5 9.994C32.5 8.46467 33.0353 7.16667 34.106 6.1C35.1767 5.03333 36.4767 4.5 38.006 4.5C39.5353 4.5 40.8333 5.03533 41.9 6.106C42.9667 7.17667 43.5 8.47667 43.5 10.006C43.5 11.5353 42.9647 12.8333 41.894 13.9C40.8233 14.9667 39.5233 15.5 37.994 15.5Z"
      fill="white"
    />
  </svg>
);
